import { popupCenter } from '@account-service/core'
import { PUBLIC_CLIENT_URL } from '@account-service/core/envs'
import { useRouter } from 'next/router'
import { useCallback, useEffect, useRef, useState } from 'react'

import type { TChangeEmailModalProps } from '~/components/Modals/ChangeEmailModal'
import { NiceModal } from '~/components/NiceModal'
import { toUrlMFALogin } from '~/configs/auth'
import { HEIGHT_POPUP_WINDOW } from '~/constants'
import { ModalKey } from '~/constants/modal'
import { ModeAction } from '~/constants/mode'
import { useAuthContext } from '~/hooks/useAuthContext'

export const useEmailSignIn = () => {
  const { user, settings, logout } = useAuthContext()
  const router = useRouter()

  const [errors, setErrors] = useState({ email: '' })
  const windowRef = useRef<Window | null>(null)

  const accountLinked = user?.email

  const modeEmail: ModeAction = accountLinked
    ? ModeAction.CHANGE
    : ModeAction.SETUP

  const modePassword: ModeAction = settings?.is_empty_password
    ? ModeAction.SETUP
    : ModeAction.CHANGE

  const onSetupEmail = useCallback(() => {
    router.replace('/security')
  }, [router])

  const onChangeEmail = useCallback(() => {
    const url = toUrlMFALogin({
      redirect_uri: `${PUBLIC_CLIENT_URL}/mfa/callback`,
      scope: 'account:profile.email:update',
    })

    windowRef.current = popupCenter({
      url,
      h: HEIGHT_POPUP_WINDOW,
    })
  }, [])

  useEffect(() => {
    window.addEventListener('message', event => {
      if (event.origin === window.location.origin) {
        const { data } = event

        if (data && data.type === 'mfa') {
          const mfaData = data?.payload?.data
          const error = data?.payload?.error

          if (error === 'login_required') {
            windowRef.current?.close()
            logout()
            return
          }

          windowRef.current?.close()

          NiceModal.show<TChangeEmailModalProps>(ModalKey.CHANGE_EMAIL, {
            accessToken: mfaData?.access_token,
          })
        }
      }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    modeEmail,
    modePassword,
    errors,
    setErrors,
    onChangeEmail,
    onSetupEmail,
  }
}
